import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility';
import { MedicalConditionUrl } from '../../../shared/urls/master-data.medical-condition.urls';

@Injectable()
export class AdministerVaccineService {
    constructor(public baseService: BaseService) { }
    getPatientInfo(id) {
        const url = PatientUrl.GET_PATIENT_ACCOUNT.replace('{id}', id);
        return this.baseService.getData(url, null);
    }
    getSiteVaccineData() {
        const url = MasterDataUrl.GET_SITE_TO_ADMINISTER;
        return this.baseService.getData(url, null);
    }
    getSelectPregnancy(patientId,consultationId) {
        return this.baseService.getData(MedicalConditionUrl.MEDICALCONDITION_FEMALE, {patientId:patientId,consultationId:consultationId});
    }
    getDataVaccine(id) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION, [id]);
        return this.baseService.getData(url);
    }
    updateAdministerVaccine(id, data, valuePregnancy, isMoveNextStep) {
        let url = Utility.stringFormat(ConsultationUrl.GET_ADMINISTER_VACCINE, [id]);
        url += '?isMoveNextStep='+ isMoveNextStep;
        if (valuePregnancy) {
            url = url + '&valuePregnancy=' + valuePregnancy;
        }
        return this.baseService.postData(url, data);
    }
}

// export const roleData = [
//     {
//         id: 1,
//         name: 'L-Arm'
//     },
//     {
//         id: 2,
//         name: 'R-Arm'
//     },
//     {
//         id: 3,
//         name: 'L-Leg'
//     },
//     {
//         id: 4,
//         name: 'R-Leg'
//     },
//     {
//         id: 5,
//         name: 'Oral'
//     },
//     {
//         id: 6,
//         name: 'Buttocks'
//     }

// ];
// export const selectPregnancy = [
//     {
//         id: 1,
//         option: 'Pregnancy – Current',
//     },
//     {
//         id: 2,
//         option: 'Not Pregnant',
//     },
//     {
//         id: 3,
//         option: 'Pregnancy - Planned',
//     }
// ];
// export const dataRows = [
//     {
//         id: 1,
//         vaccineName: 'Diphitheria/Tetanus Vaccine',
//         batchNumberId: 1,
//         batches: [{
//             id: '1',
//             name: 'Batch 001'
//         },
//         {
//             id: '2',
//             name: 'Batch 002'
//         },
//         {
//             id: '3',
//             name: 'Batch 003'
//         }
//         ],
//         medicalCondition: 'Display the medical condition separated by comma',
//         isHighLight: true,
//         siteId: 'null',
//     },
//     {
//         id: 2,
//         vaccineName: 'Diphitheria/Tetanus Vaccine 2',
//         batchNumberId: 2,
//         batches: [{
//             id: '1',
//             name: 'Batch 003'
//         },
//         {
//             id: '2',
//             name: 'Batch 004'
//         }
//         ],
//         isHighLight: true,
//         medicalCondition: 'Display the medical condition separated by comma',
//         siteId: 'null',
//     },
// ];
// export const dataVaccines = [
//     {
//         vaccineId: '1',
//         vaccineName: 'Diphitheria/Tetanus Vaccine',
//         noOfAdminister: '2',
//         vaccineDates: [
//             { isChecked: true, date: 1413173580, visit: 'current' }, //visit: 'current', 'next', 'past'
//             { isChecked: true, date: 1413173580, visit: 'next' },
//             { isChecked: false, date: 1413173580, visit: 'past' },
//         ]
//     },
//     {
//         vaccineId: '1',
//         vaccineName: 'Diphitheria/Tetanus Vaccine 2',
//         noOfAdminister: '3',
//         vaccineDates: [
//             { isChecked: true, date: 1413173580, visit: 'current' }, //visit: 'current', 'next', 'past'
//             { isChecked: true, date: 1413173580, visit: 'next' },
//             { isChecked: true, date: 1413173580, visit: 'past' }
//         ]
//     }

// ];





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/administer-vaccine/administer-vaccine.service.ts